import {
  CHANGE_OPERATIONS,
  CHANGE_SWAP_SEARCH
} from './actions'

export default function(state = {
  search: '',
  operations: []
}, action) {
  switch(action.type) {
    case CHANGE_OPERATIONS:
      return { ...state, operations: action.payload }
    case CHANGE_SWAP_SEARCH:
      return { ...state, search: action.payload }
    default:
      return state
  }
}
